"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var utils_1 = __importDefault(require("@nexys/utils"));

var ui_1 = require("./ui");

var order_utils_1 = require("./utils/order-utils");

var filter_utils_1 = require("./utils/filter-utils");

var pagination_utils_1 = require("./utils/pagination-utils");

var list_super_partials_1 = require("./list-super-partials");

var ListSuper = function ListSuper(_ref) {
  var HeaderUnit = _ref.HeaderUnit,
      FilterUnit = _ref.FilterUnit,
      OrderController = _ref.OrderController,
      ColCell = _ref.ColCell,
      GlobalSearch = _ref.GlobalSearch,
      NoRow = _ref.NoRow,
      Row = _ref.Row,
      ListWrapper = _ref.ListWrapper,
      ListContainer = _ref.ListContainer,
      ListHeader = _ref.ListHeader,
      ListBody = _ref.ListBody,
      RecordInfo = _ref.RecordInfo,
      Pagination = _ref.Pagination;
  return function InnerListSuper(props) {
    var _react_1$useReducer = react_1.useReducer(list_super_partials_1.listSuperReducer, list_super_partials_1.getInitialState(props.data)),
        _react_1$useReducer2 = _slicedToArray(_react_1$useReducer, 2),
        state = _react_1$useReducer2[0],
        dispatch = _react_1$useReducer2[1];

    var def = props.def,
        _props$config = props.config,
        config = _props$config === void 0 ? {} : _props$config,
        asyncData = props.asyncData;
    var filters = state.filters,
        pageIdx = state.pageIdx,
        sortAttribute = state.sortAttribute,
        sortDescAsc = state.sortDescAsc,
        data = state.data,
        numberOfTotalRows = state.numberOfTotalRows,
        loading = state.loading;
    var nPerPage = config.nPerPage || props.nPerPage || 25;

    if (props.nPerPage) {
      console.warn('The use of nPerPage in props is deprecated. Add nPerPage to the config object prop.');
    }

    var fetchData = react_1.useCallback(function (config) {
      if (asyncData) {
        dispatch({
          type: list_super_partials_1.ActionType.FETCH_DATA_REQUEST
        });
        asyncData({
          nPerPage: nPerPage,
          pageIdx: config && config.pageIdx ? config.pageIdx : pageIdx,
          filters: config && config.filters ? config.filters : filters,
          sort: {
            attribute: config && config.sortAttribute ? config.sortAttribute : sortAttribute,
            descAsc: config && typeof config.sortDescAsc !== 'undefined' ? config.sortDescAsc : sortDescAsc
          }
        }).then(function (res) {
          dispatch({
            type: list_super_partials_1.ActionType.FETCH_DATA_SUCCESS,
            payload: {
              data: res.data,
              numberOfTotalRows: res.meta.n
            }
          });
        });
      }
    }, [asyncData, filters, nPerPage, pageIdx, sortAttribute, sortDescAsc]);
    react_1.useEffect(function () {
      fetchData();
    }, [asyncData, fetchData]);

    var handleFilterChange = function handleFilterChange(v) {
      var newFilters = filter_utils_1.updateFilters(filters, v); // when a filter is applied, the page index is reset

      var pageIdx = 1;
      var config = {
        filters: newFilters,
        pageIdx: pageIdx
      };
      dispatch({
        type: list_super_partials_1.ActionType.FILTER_CHANGE,
        payload: config
      });
      fetchData(config);
    };
    /**
     * defines order to apply
     * @param  {[type]} name    attribute/column
     * @param  {[type]} descAsc true/false - asc or desc. if null, will toggle
     * @return {[type]}         [description]
     * todo: allow custom ordering
     */


    var setOrder = function setOrder(name) {
      var descAsc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (descAsc === null) {
        descAsc = !sortDescAsc;
      }

      var config = {
        sortDescAsc: descAsc,
        sortAttribute: name,
        pageIdx: 1
      };
      dispatch({
        type: list_super_partials_1.ActionType.ORDER_CHANGE,
        payload: config
      });
    };

    var changePage = function changePage(pageIdx) {
      // todo block beyond max page
      if (pageIdx > 0) {
        var _config = {
          pageIdx: pageIdx
        };
        dispatch({
          type: list_super_partials_1.ActionType.PAGE_CHANGE,
          payload: _config
        });
      }
    };

    var isSort = function isSort(h) {
      return typeof h.sort === 'boolean' && h.sort === true || typeof h.sort === 'object';
    };

    var renderHeaders = function renderHeaders() {
      return def.map(function (h, i) {
        var label = h.label === null ? null : h.label || h.name;
        var order = isSort(h) ? react_1.default.createElement(OrderController, {
          descAsc: sortAttribute === h.name ? sortDescAsc : null,
          onClick: function onClick() {
            return setOrder(h.name);
          }
        }) : null;
        var filter = react_1.default.createElement(FilterUnit, {
          key: i,
          filters: filters,
          name: h.name,
          filter: h.filter,
          onChange: handleFilterChange
        });
        return react_1.default.createElement(HeaderUnit, {
          key: i
        }, label, " ", order, " ", filter);
      });
    };

    var renderBody = function renderBody(data) {
      return react_1.default.createElement(react_1.default.Fragment, null, data.map(function (row, i) {
        return react_1.default.createElement("tr", {
          key: i
        }, def.map(function (h, j) {
          return react_1.default.createElement(ColCell, {
            key: j
          }, h.render ? h.render(row) : utils_1.default.ds.get(h.name.toString(), row));
        }));
      }));
    };

    var renderLoader = function renderLoader() {
      return react_1.default.createElement("tr", null, react_1.default.createElement(ColCell, {
        colSpan: def.length
      }, react_1.default.createElement(ui_1.Loader, null)));
    };

    var fData = [];
    var fpData = [];
    var n = 0;

    if (!asyncData) {
      fData = filter_utils_1.applyFilter(data, filter_utils_1.toFilterArray(filters));
      n = fData.length;
      fpData = sortAttribute ? pagination_utils_1.withPagination(order_utils_1.order(fData, order_utils_1.getSort(def, sortAttribute), sortDescAsc), pageIdx, nPerPage) : pagination_utils_1.withPagination(fData, pageIdx, nPerPage);
    } else {
      n = numberOfTotalRows;
    }

    var showPagination = typeof config.pagination !== 'undefined' ? config.pagination : true;
    return react_1.default.createElement(ListWrapper, null, react_1.default.createElement(GlobalSearch, {
      config: config,
      onChange: handleFilterChange,
      filters: filters
    }), react_1.default.createElement(ListContainer, null, react_1.default.createElement(ListHeader, null, react_1.default.createElement(Row, null, renderHeaders())), react_1.default.createElement(ListBody, null, loading ? renderLoader() : renderBody(asyncData ? data : fpData))), react_1.default.createElement(RecordInfo, {
      n: n,
      idx: pageIdx,
      nPerPage: nPerPage
    }), showPagination && n > nPerPage && react_1.default.createElement(Pagination, {
      n: n,
      nPerPage: nPerPage,
      idx: pageIdx,
      onClick: changePage
    }), !loading && react_1.default.createElement(NoRow, {
      n: n
    }));
  };
};

exports.default = ListSuper;